/* eslint no-use-before-define: 0 */  // --> OFF
import React, { useEffect, useReducer } from "react";
import ImageWrapper from "../ImageComponent/ImageWrapper";
import { useRouter } from "next/router";
import toast from "react-hot-toast";
import { POSTREQUESTAPI } from "@/pages/api/apiUtils";
import { getCookieItem } from "@/utils/utils";
import {
  AUTH_EMAIL_SEND_OTP,
  AUTH_EMAIL_VERIFY_OTP,
  BACKEND_API_ROUTE,
} from "@/commons/api_routes";
import OTPInput from "react-otp-input";

const initialState = {
  email: "",
  emailOtp: "",
  showEmailInput: true,
  isValidEmail: true,
  emailOtpSent: false,
  emailVerified: false,
  loading: false,
  emailLoading: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_EMAIL":
      return { ...state, email: action.payload };
    case "SET_EMAIL_OTP":
      return { ...state, emailOtp: action.payload };
    case "SET_SHOW_EMAIL_INPUT":
      return { ...state, showEmailInput: action.payload };
    case "SET_IS_VALID_EMAIL":
      return { ...state, isValidEmail: action.payload };
    case "SET_EMAIL_OTP_SENT":
      return { ...state, emailOtpSent: action.payload };
    case "SET_EMAIL_VERIFIED":
      return { ...state, emailVerified: action.payload };
    case "SET_IS_LOADING":
      return { ...state, loading: action.payload };
    case "SET_EMAIL_LOADING":
      return { ...state, emailLoading: action.payload };
    default:
      return state;
  }
};

const BookingModal = (props) => {
  const { userData, orderId, loading } = props;
  const [state, dispatch] = useReducer(reducer, initialState);
  const router = useRouter();

  useEffect(() => {
    if (!loading) {
      const timeoutId = setTimeout(() => {
        router.push(`/user/orders/${orderId}`);
      }, 7000);

      return () => clearTimeout(timeoutId);
    }
  }, [userData, router, loading, orderId]);

  const handleEmailChange = (e) => {
    const inputValue = e.target.value;
    const isValidEmail =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        inputValue
      );

    dispatch({ type: "SET_EMAIL", payload: inputValue });
    dispatch({ type: "SET_IS_VALID_EMAIL", payload: isValidEmail });

    if (!isValidEmail) {
      dispatch({
        type: "SET_ERROR",
        payload: "Please enter a valid email address.",
      });
    } else {
      dispatch({ type: "SET_ERROR", payload: "" });
      dispatch({
        type: "SET_FORM_DATA",
        payload: { ...state.formData, email: inputValue },
      });
    }
  };

  const handleEmailChangeClick = () => {
    dispatch({ type: "SET_SHOW_EMAIL_INPUT", payload: true });
    dispatch({ type: "SET_EMAIL_OTP_SENT", payload: false });
    dispatch({ type: "SET_EMAIL_OTP", payload: "" });
    dispatch({ type: "SET_ERROR", payload: "" });
    dispatch({ type: "SET_EMAIL_OTP_SENT", payload: false });
    // dispatch({ type: "SET_RESEND_DISABLED", payload: false });
    // dispatch({ type: "SET_RESEND_COUNTDOWN", payload: 60 });
  };

  const sendEmailOTPApi = async () => {
    dispatch({ type: "SET_EMAIL_LOADING", payload: true });
    try {
      const sendEmailUrl = BACKEND_API_ROUTE + AUTH_EMAIL_SEND_OTP;
      const accessToken = getCookieItem("accessToken");

      const response = await POSTREQUESTAPI(
        sendEmailUrl,
        {
          email: state.email,
        },
        accessToken
      );

      if (response && response.status === 201) {
        const data = await response.data;
        if (data.statusCode === 200) {
          toast.success(data.message);
          dispatch({ type: "SET_EMAIL_OTP_SENT", payload: true });
          dispatch({ type: "SET_SHOW_EMAIL_INPUT", payload: false });
        } else {
          toast.error("OTP Sending Failed");
        }
      } else {
        const errorData = await response.json();
        toast.error("API Error Response:", errorData);
      }
    } catch (error) {
      toast.error("Error sending OTP:", error);
    } finally {
      dispatch({ type: "SET_EMAIL_LOADING", payload: false });
    }
  };

  const verifyEmailOTPApi = async () => {
    try {
      const emailVerifyUrl = BACKEND_API_ROUTE + AUTH_EMAIL_VERIFY_OTP;
      const accessToken = getCookieItem("accessToken");

      const response = await POSTREQUESTAPI(
        emailVerifyUrl,
        {
          otp: state.emailOtp,
          email: state.email,
        },
        accessToken
      );

      if (response.status === 201) {
        const data = await response.data;
        if (data.statusCode === 200) {
          toast.success(data.message);
          dispatch({ type: "SET_EMAIL_VERIFIED", payload: true });
        } else {
          toast.error(data.error);
        }
      } else {
        const errorData = await response.json();
        toast.error("API Error Response:", errorData);
      }
    } catch (error) {
      toast.error("Error verifying OTP:", error);
    }
  };

  const handleSendEmailOTPClick = () => {
    if (state.isValidEmail) {
      sendEmailOTPApi();
    } else {
      toast.error("Please enter a valid email address.");
    }
  };

  const handleVerifyEmailOTPClick = () => {
    verifyEmailOTPApi();
  };

  const handleEmailOTPChange = (otpValue) => {
    dispatch({ type: "SET_EMAIL_OTP", payload: otpValue });
    dispatch({ type: "SET_ERROR", payload: "" });
  };

  return (
      <main
          className="fixed top-0 left-0 w-full h-full flex items-center z-[60] justify-center bg-ModalTransparentColor ">
        <div
            className="flex flex-col bg-white w-[324px] md:w-[444px] max-w-[444px] xs:max-w-[344px] sm:max-w-md rounded-2xl h-auto min-h-[291px] relative overflow-hidden">
          {/*Change the below condition to userData.email when you want to verify users email */}
          {userData._id ? (
              <div className="relative inset-0 w-full h-full mx-auto">
                {/* Top booking icon */}
                <div className="absolute left-1/2 -translate-x-1/2 -top-10
                   rounded-full border shadow-lg bg-white
                   w-[80px] xs:w-16 sm:w-20
                   h-[80px] xs:h-16 sm:h-20
                   flex items-center justify-center
                   z-10">
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img
                      src="/icons/Group6728.svg"
                      alt="booking"
                      className="w-8 xs:w-9 sm:w-11 h-7 xs:h-8 sm:h-10"
                  />
                </div>

                <div className="relative overflow-hidden  rounded-t-2xl   h-full">
                  {/* Left top floral design */}
                  <div className="absolute left-2 top-2">
                    <img
                        src="/icons/Group 6937.svg"
                        alt="floral design"
                        className="w-8 xs:w-10 sm:w-[50px] h-8 xs:h-10 sm:h-[50px]"
                    />
                  </div>

                  {/* Right top checkmark */}

                  {/* Logo */}
                  <div
                      className="text-xl sm:text-2xl font-bold font-roboto text-BluntRed pt-12 sm:pt-14 pb-2 text-center mt-5">
                    <img
                        src="/icons/book-my-pooja.svg"
                        alt="Book my pooja logo"
                        className="h-12 xs:h-16 sm:h-20 w-auto mx-auto"
                    />
                  </div>

                  {loading ? (
                      <div className="text-Default text-center pb-12 sm:pb-16">
                        Processing your payment
                      </div>
                  ) : (
                      <>
                        <div className="flex flex-col items-center px-6 sm:px-8">
                          <div className="flex items-center mt-2 sm:mt-4 mb-4 sm:mb-6">
                            <p className="text-base xs:text-lg sm:text-xl text-[#475569] font-poppins font-medium">
                              Order Successful
                            </p>
                            <img
                                src="/icons/tick.svg"
                                alt="tick-icon"
                                className="w-4 xs:w-5 sm:w-6 h-4 xs:h-5 sm:h-6 ml-2"
                            />
                          </div>

                          <div className="w-full bg-slate-50 rounded-xl p-4 sm:p-5 border border-slate-100 mb-6 shadow-sm">
                            <h3 className="text-BluntRed font-bold text-sm sm:text-base mb-2 uppercase tracking-wide">Next step</h3>
                            
                            <div className="space-y-4">
                              <div>
                                <p className="text-[#475569] text-xs sm:text-sm font-medium mb-2">
                                  Assigning pandit ji to the following:
                                </p>
                                <ul className="space-y-2 ml-1">
                                  <li className="flex items-center text-[#1E293B] text-xs sm:text-sm">
                                    <div className="w-1.5 h-1.5 rounded-full bg-BluntRed mr-3 flex-shrink-0"></div>
                                    Pandit ji assignment
                                  </li>
                                  <li className="flex items-center text-[#1E293B] text-xs sm:text-sm">
                                    <div className="w-1.5 h-1.5 rounded-full bg-BluntRed mr-3 flex-shrink-0"></div>
                                    Home preparation checklist
                                  </li>
                                </ul>
                              </div>

                              <div className="pt-3 border-t border-slate-200">
                                <p className="text-[#64748B] text-[10px] sm:text-xs leading-relaxed">
                                  Priest assignment is underway. Home preparation checklist will also be shared to you within 24-48 hours, for complete readiness from your end.
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="flex items-center justify-center pb-6">
                             <p className="text-blue-500 text-[10px] sm:text-xs font-medium animate-pulse flex items-center">
                               <span className="mr-2">Redirecting to Order Page</span>
                               <span className="flex gap-0.5">
                                 <span className="w-0.5 h-0.5 bg-current rounded-full animate-bounce"></span>
                                 <span className="w-0.5 h-0.5 bg-current rounded-full animate-bounce [animation-delay:0.2s]"></span>
                                 <span className="w-0.5 h-0.5 bg-current rounded-full animate-bounce [animation-delay:0.4s]"></span>
                               </span>
                             </p>
                          </div>
                        </div>
                      </>
                  )}

                  {/* Bottom left floral design */}
                  <div className="absolute -left-7 -bottom-5">
                    <img
                        src="/icons/floral-design-orange.svg"
                        alt="floral design"
                        className="w-16 xs:w-20 sm:w-[100px] h-16 xs:h-20 sm:h-[100px]"
                    />
                  </div>

                  {/* Top right floral design */}
                  <div className="absolute -right-8 sm:-right-12 top-16">
                    <img
                        src="/icons/floral-design-orange.svg"
                        alt="floral design"
                        className="w-12 xs:w-16 sm:w-[85px] h-12 xs:h-16 sm:h-[85px]"
                    />
                  </div>
                </div>
              </div>

          ) : (
              <>
                <form>
                  <div className="px-4">
                    <p className="px-4 py-3 rounded-lg text-Default capitalize">
                      For further communication please verify your email
                    </p>
                    <fieldset
                        className={`${!state.isValidEmail ? "mb-2" : ""} ${
                            state.showEmailInput
                                ? "border border-light-grey-color h-12 mb-6"
                                : "h-full"
                        }  w-full rounded-md`}
                    >
                      {state.showEmailInput ? (
                          <>
                            <legend className={`mx-3 px-1 text-xs`}>Email</legend>
                            <div className="flex flex-row justify-start items-center px-4">
                              <div className="relative w-4 h-4">
                                <ImageWrapper src="/icons/Profile_Red.svg" alt="d"/>
                              </div>
                              <input
                                  type="email"
                                  placeholder="Email"
                                  className={`w-full border-0 placeholder:text-[#47556980] bg-transparent focus:outline-none placeholder:text-PH_Default placeholder:text-sm rounded-md px-2 ${
                                      !state.isValidEmail ? "border-red-500" : ""
                                  }`}
                                  value={userData.email ? userData.email : state.email}
                                  onChange={handleEmailChange}
                              />
                            </div>
                            {!state.isValidEmail && (
                                <div className="text-xs text-red-500 px-4 my-2">
                                  Please enter a valid email address.
                                </div>
                            )}
                            {!state.emailOtpSent && (
                                <button
                                    onClick={handleSendEmailOTPClick}
                                    className="text-sm text-BluntRed py-3"
                                >
                                  Send Email OTP
                                </button>
                            )}
                          </>
                      ) : (
                          <>
                            <div className="flex flex-row gap-4 justify-start items-center">
                              <div className="text-[#707070] text-sm leading-4">
                                {state.email}
                              </div>
                              <button
                                  className="text-[#0A66FF] font-medium text-xs leading-4"
                                  onClick={handleEmailChangeClick}
                              >
                                Change
                              </button>
                            </div>
                            <div className="mt-2">
                              <h4 className="text-xs text-[#707070] tracking-tighter leading-none">
                                Enter OTP sent to your email address
                              </h4>
                              <div className="flex flex-col justify-start text-start gap-1 mt-1">
                                <OTPInput
                                    inputType="tel"
                                    value={state.emailOtp}
                                    onChange={handleEmailOTPChange}
                                    numInputs={6}
                                    renderSeparator={<span> </span>}
                                    renderInput={(props) => <input {...props} />}
                                    inputStyle={{
                                      border: "1px solid #94A3B8",
                                      borderRadius: "4px",
                                      width: "32px",
                                      height: "32px",
                                      fontSize: "16px",
                                      color: "#475569",
                                      fontWeight: "400",
                                      caretColor: "blue",
                                      margin: "0 8px 0 0",
                                    }}
                                    focusStyle={{
                                      border: "1px solid transparent",
                                      outline: "none",
                                    }}
                                />
                                {state.error ? (
                                    <div
                                        className="text-xs overflow-x-visible"
                                        style={{color: "red"}}
                                    >
                                      {state.error}
                                    </div>
                                ) : (
                                    ""
                                )}
                              </div>
                            </div>
                          </>
                      )}
                      {state.emailOtpSent && (
                          <>
                            <button
                                onClick={handleVerifyEmailOTPClick}
                                className="text-sm text-BluntRed pt-2"
                            >
                              Verify OTP
                            </button>
                          </>
                      )}
                    </fieldset>
                    {state.emailVerified && (
                        <div className="flex flex-col gap-2">
                          <div className="text-Default font-semibold tracking-wide leading-5 text-sm">
                            {state.email}
                          </div>
                          <div className="text-[#1B9A60] text-xs font-medium">
                            Email Verified Successfully !!
                          </div>
                        </div>
                    )}
                  </div>
                </form>
              </>
          )}
        </div>
      </main>
  );
};

export default BookingModal;
